export default "__VITE_ASSET__e1TZLpLg__"